<template>
  <div class="field">
    <label
      class="label"
      :for="id"
    >
      {{ label }}
    </label>
    <div
      class="control"
      :class="{ 'is-loading': isLoading }"
    >
      <div
        class="select is-fullwidth"
        :class="{ 'select-disabled': disabled }"
      >
        <select
          :id="id"
          :name="name"
          :disabled="disabled"
          :required="required"
          @change="$emit('change', $event)"
        >
          <option :value="placeholderOption">
            {{ placeholder }}
          </option>
          <option
            v-for="(option, index) in options"
            :key="index"
            :value="option.value"
            :selected="option.value === value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSelectField',
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: [String, Number],
      default: '',
    },
    pattern: {
      type: String,
      default: '',
    },
    leftIcon: {
      type: String,
      default: '',
    },
    rightIcon: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholderOption: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
select option:first-child {
  display: none;
}

.select.select-disabled:not(.is-multiple):not(.is-loading)::after {
  display: none;
}
</style>
